/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_Moved_ToastInputs */

const en_us2_plan_edit_moved_toast = /** @type {(inputs: Plan_Edit_Moved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order changed`)
};

const pt_br2_plan_edit_moved_toast = /** @type {(inputs: Plan_Edit_Moved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordem alterada`)
};

const es_419_plan_edit_moved_toast = /** @type {(inputs: Plan_Edit_Moved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orden cambiado`)
};

const pt_pt2_plan_edit_moved_toast = /** @type {(inputs: Plan_Edit_Moved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordem alterada`)
};

const fr_fr2_plan_edit_moved_toast = /** @type {(inputs: Plan_Edit_Moved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordre modifié`)
};

const de_de2_plan_edit_moved_toast = /** @type {(inputs: Plan_Edit_Moved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge geändert`)
};

const it_it2_plan_edit_moved_toast = /** @type {(inputs: Plan_Edit_Moved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordine cambiato`)
};

/**
* | output |
* | --- |
* | "Order changed" |
*
* @param {Plan_Edit_Moved_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_moved_toast = /** @type {((inputs?: Plan_Edit_Moved_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Moved_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_moved_toast(inputs)
	if (locale === "es-419") return es_419_plan_edit_moved_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_moved_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_moved_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_moved_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_moved_toast(inputs)
	return en_us2_plan_edit_moved_toast(inputs)
});
export { plan_edit_moved_toast as "plan-edit.moved_toast" }